import { createFileRoute } from '@tanstack/react-router';

import {
  StarvationBidder,
  StarvationBidderSearchParamsSchema,
} from '@/features/starvationBidder';

export const Route = createFileRoute('/_app/algorithm-tools/starvation-bidder')(
  {
    validateSearch: StarvationBidderSearchParamsSchema,
    component: RouteComponent,
  }
);

function RouteComponent() {
  return <StarvationBidder />;
}
